import React from 'react';

type Props = {
  label?: string | undefined;
  disabled?: boolean | undefined;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

export const CancelButton: React.VFC<Props> = ({ label, disabled, onClick }) => {
  return (
    <button
      className="w-fit rounded border border-red-600 text-red-600 hover:bg-red-100 disabled:text-red-300 disabled:border-red-300 disabled:bg-transparent px-2 py-1"
      disabled={disabled}
      onClick={onClick}
    >
      {label ?? 'キャンセル'}
    </button>
  );
};
